import { render, staticRenderFns } from "./GenericUpdateMSList.vue?vue&type=template&id=4b86853f&scoped=true"
import script from "./GenericUpdateMSList.vue?vue&type=script&lang=js"
export * from "./GenericUpdateMSList.vue?vue&type=script&lang=js"
import style0 from "./GenericUpdateMSList.vue?vue&type=style&index=0&id=4b86853f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b86853f",
  null
  
)

export default component.exports